// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"4812fd5b","233":"d54ee01b","369":"7e08b63f","777":"d85915b3","936":"72c5586a"}[chunkId] + ".js";
};